import { render } from "./InternetAccessPopup.vue?vue&type=template&id=5d7a1092&scoped=true"
import script from "./InternetAccessPopup.vue?vue&type=script&lang=js"
export * from "./InternetAccessPopup.vue?vue&type=script&lang=js"

import "./InternetAccessPopup.vue?vue&type=style&index=0&id=5d7a1092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7a1092"]])

export default __exports__